import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={20}
    height={34}
    viewBox={'0 0 20 34'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <Path
      stroke={props.fill || '#000'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.97}
      d="M7.344 33.24c-.79-3.11-.69-3.5-2.53-5.96-1.36-1.82-2.34-3.85-3.58-6.02-.48-.83-.2-1.89.63-2.37.83-.48 1.89-.19 2.37.63.56.97 1.12 1.94 1.68 2.92.4.6 1.44.11 1.42-.5V11.38c0-.76.62-1.38 1.37-1.38.75 0 1.38.62 1.38 1.38v6.42c0-.76.62-1.38 1.37-1.38.75 0 1.37.62 1.37 1.38v.64a1.374 1.374 0 1 1 2.75 0v1.29a1.374 1.374 0 1 1 2.75 0c.27 3.28.54 5.97-.64 8.32-.77 1.91-.96 3.1-1.52 5.21M3.35 7.038l.036-6.03L2.024 3.01"
    />
    <Path
      stroke={props.fill || '#000'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.97}
      d="m3.35 7.038.036-6.03L2.024 3.01M3.386 1.008l1.328 2.018M3.386 1.008l1.328 2.018M3.405 11l-.065 6.03 1.372-1.996"
    />
    <Path
      stroke={props.fill || '#000'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.97}
      d="m3.405 11-.065 6.03 1.372-1.996M3.34 17.03l-1.318-2.025M3.34 17.03l-1.318-2.025"
    />
  </Svg>
);
export default SvgComponent;
